<template>
  <div @click="close_modal()" class="authModal" style="--gap: -17px">
    <div @click.stop class="auth-modal__content">
      <div class="m-transition">
        <div class="w-100">
          <form class="authLayout">
            <div class="auth-layout__header">
              <img v-if="step !== 3" src="/img/amlakLogo.png" alt="Logo" />
              <img v-if="step === 3" src="/img/login.png" alt="" />
              <div
                v-if="step === 2"
                @click="BackToSite"
                role="button"
                class="auth-layout__button auth-layout__button--back"
              >
                <VsxIcon
                  iconName="ArrowRight"
                  :size="21"
                  color="#000"
                  type="linear"
                />
              </div>
              <div
                @click="close_modal()"
                role="button"
                class="auth-layout__button auth-layout__button--close"
              >
                <!-- <VsxIcon iconName="CloseCircle" :size="30" color="#000" type="linear"/> -->
                <i class="fas fa-xmark"></i>
              </div>
            </div>
            <div
              v-if="step === 1"
              class="auth-layout__container thirdStepContent"
            >
              <h6 class="auth-layout__title">ورود | ثبت‌نام</h6>
              <p class="auth-layout__caption">
                لطفا شماره موبایل خود را وارد کنید
              </p>
              <div class="auth-layout__content">
                <div
                  class="userTypeButtons"
                >
                  <button
                    class="userTypeButton"
                    :class="{ selected: form.userType == 'customer' }"
                    @click="userTypeHandler($event, 'customer')"
                  >
                    <i class="fa-solid fa-user"></i>
                    مشتری
                  </button>
                  <button
                    class="userTypeButton"
                    :class="{ selected: form.userType == 'branch_admin' }"
                    @click="userTypeHandler($event, 'branch_admin')"
                  >
                    <i class="fa-solid fa-building"></i>
                    املاک
                  </button>
                  <!-- <button
                    class="userTypeButton"
                    :class="{ selected: form.userType === 'builder' }"
                    @click="userTypeHandler($event, 'builder')"
                  >
                    <i class="fa-solid fa-hard-hat"></i>
                    سازنده
                  </button> -->
                  <button
                    class="userTypeButton"
                    :class="{ selected: form.userType == 'consultant' }"
                    @click="userTypeHandler($event, 'consultant')"
                  >
                    <i class="fa-solid fa-hand"></i>
                    مباشر
                  </button>
                </div>

                <div class="c-input mo-input__input">
                  <label
                    class="c-input__container"
                    :class="{ 'c-input__container--error': showerror }"
                    ><input
                      type="tel"
                      name="tel"
                      maxlength="11"
                      autocomplete="home tel"
                      placeholder="۰۹xxxxxxxxx"
                      v-model="Mobile"
                      class="c-input__field c-input__field--ltr c-input__field--ltr-placeholder"
                  /></label>
                  <p v-if="showerror" class="c-input__error">
                    {{ error_title }}
                  </p>
                </div>
                <div class="auth-layout__footer">
                  <div v-if="!loading" @click="BtnSendCode" class="auth-submit">
                    <span>ارسال کد</span>
                  </div>

                  <div v-if="loading" class="auth-submit">
                    <div>
                      <span class="loader"></span>
                    </div>
                  </div>
                </div>
                <p class="rule">
                  ورود شما به معنای پذیرش
                  <a target="_blank" class="rule-link">شرایط شمال املاک</a>
                  و
                  <a target="_blank" class="rule-link">قوانین حریم خصوصی</a>
                  است.
                </p>
              </div>
            </div>
            <div v-if="step === 2" class="auth-layout__container">
              <h6 class="auth-layout__title">تایید شماره موبایل</h6>
              <p class="auth-layout__caption">
                کد 5 رقمی ارسال‌شده به شماره ”{{ Mobile }}” را واردکنید.
              </p>
              <div class="auth-layout__content">
                <div class="otp-form">
                  <div class="c-input">
                    <label
                      class="c-input__container c-input__container--disabled"
                    >
                      <span @click="BackToSite" class="c-input__icon">
                        <span role="button" class="otp-form__mobile"
                          >ویرایش شماره</span
                        >
                      </span>
                      <input
                        v-model="Mobile"
                        disabled
                        class="c-input__field c-input__field--ltr"
                      />
                    </label>
                    <div class="otp-inputs otp-form__inputs">
                      <div class="otp-inputs__container">
                        <div
                          class="otp-inputs__cell"
                          v-for="(input, index) in inputs"
                          :key="index"
                        >
                          <label class="otp-input">
                            <input
                              v-model="input.value"
                              @input="handleInput(index)"
                              @keydown="handleKeydown(index, $event)"
                              :ref="(el) => (inputRefs[index] = el)"
                              pattern="[0-9]*"
                              maxlength="1"
                              autocomplete="one-time-code"
                              type="tel"
                              class="otp-input__field"
                            />
                          </label>
                        </div>

                        <div class="otp-inputs__cell">
                          <button
                            @click="BtnSendCode"
                            v-if="!btnRecend"
                            class="otp-inputs__resend"
                          >
                            <VsxIcon
                              iconName="Refresh2"
                              :size="24"
                              color="#000"
                              type="linear"
                            />
                          </button>
                          <div v-if="btnRecend" class="otp-inputs__timer">
                            <VsxIcon
                              iconName="Clock"
                              :size="24"
                              color="#a4a4a4"
                              type="linear"
                            />
                            {{ formattedTime }}
                          </div>
                        </div>
                      </div>
                      <p v-if="showerror" class="c-input__error">
                        {{ error_title }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="auth-layout__footer">
                  <div class="si-otp__footer">
                    <div
                      v-if="!loading"
                      @click="BtnLoginToSite"
                      class="auth-submit"
                    >
                      <span>ورود</span>
                    </div>
                    <div v-if="loading" class="auth-submit">
                      <div>
                        <span class="loader"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="step === 3"
              class="auth-layout__container thirdStepContent"
            >
              <h6 data-v-42a22c8c="" class="auth-layout__title">
                ثبت‌نام شمال املاک
              </h6>
              <p data-v-42a22c8c="" class="auth-layout__caption">
                برای ثبت نام در شمال املاک اطلاعات خود را وارد کنید
              </p>
              <div data-v-42a22c8c="" class="auth-layout__content">
                <div
                  class="userTypeButtons"
                  style="
                    grid-template-columns: repeat(1, 31%);
                    justify-content: center;
                  "
                >
                  <div
                    class="userTypeButton"
                    v-if="form.userType == 'customer'"
                  >
                    <i class="fa-solid fa-user"></i>
                    مشتری
                  </div>
                  <div
                    class="userTypeButton"
                    v-if="form.userType == 'branch_admin'"
                  >
                    <i class="fa-solid fa-building"></i>
                    املاک
                  </div>
                  <!-- <div class="userTypeButton" v-if="form.userType == 'builder'">
                    <i class="fa-solid fa-hard-hat"></i>
                    سازنده
                  </div> -->
                </div>
                <div class="c-input mo-input__input">
                  <label class="c-input__container c-input__container--error">
                    <input
                      type="text"
                      name="fName"
                      v-model="form.fName"
                      maxlength="50"
                      autocomplete="off"
                      placeholder="نام"
                      class="regFormInput c-input__field c-input__field--ltr c-input__field--ltr-placeholder"
                      :class="{ error: errors[0] }"
                      @blur="fnameValidation"
                  /></label>
                  <p
                    v-if="errors[0]"
                    class="c-input__error"
                    v-text="errors[0]"
                  ></p>
                </div>
                <div class="c-input mo-input__input">
                  <label class="c-input__container c-input__container--error">
                    <input
                      type="text"
                      name="lName"
                      v-model="form.lName"
                      maxlength="150"
                      autocomplete="off"
                      placeholder="نام خانوادگی"
                      class="regFormInput c-input__field c-input__field--ltr c-input__field--ltr-placeholder"
                      :class="{ error: errors[1] }"
                      @blur="lnameValidation"
                  /></label>
                  <p
                    v-if="errors[1]"
                    class="c-input__error"
                    v-text="errors[1]"
                  ></p>
                </div>
                <div class="c-input mo-input__input">
                  <label class="c-input__container c-input__container--error">
                    <input
                      type="tel"
                      name="codeMelli"
                      v-model="form.codeMelli"
                      maxlength="10"
                      autocomplete="off"
                      placeholder="کد ملی"
                      class="regFormInput c-input__field c-input__field--ltr c-input__field--ltr-placeholder"
                      :class="{ error: errors[2] }"
                      @blur="codeMelliValidation"
                  /></label>
                  <p
                    v-if="errors[2]"
                    class="c-input__error"
                    v-text="errors[2]"
                  ></p>
                </div>

                <div
                  v-if="form.userType == 'branch_admin'"
                  class="c-input mo-input__input"
                >
                  <label class="c-input__container c-input__container--error">
                    <input
                      type="text"
                      v-model="form.branch_title"
                      autocomplete="off"
                      placeholder="نام املاک"
                      class="regFormInput c-input__field c-input__field--ltr c-input__field--ltr-placeholder"
                      :class="{ error: errors[3] }"
                      @blur="branch_titleMelliValidation"
                  /></label>
                  <p
                    v-if="errors[3]"
                    class="c-input__error"
                    v-text="errors[3]"
                  ></p>
                </div>
              </div>
              <div data-v-42a22c8c="" class="auth-layout__footer">
                <button
                  v-if="!loading"
                  class="auth-submit"
                  @click="verifyRegistration($event)"
                >
                  ثبت نام
                </button>
                <div v-if="loading" class="auth-submit">
                  <div>
                    <span class="loader"></span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  name: "LoginUser",
  data() {
    return {
      step: 1,
      Mobile: "",
      showerror: false,
      error_title: "",
      loading: false,
      btnRecend: false,
      countdown: 90,
      timer: null,
      inputs: [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
      ],
      inputRefs: [], // برای ذخیره ارجاعات به ورودی‌های OTP
      form: {
        fName: "",
        lName: "",
        codeMelli: "",
        branch_title: "",
        userType: "customer",
      },
      errors: [],
    };
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    userTypeHandler(event, typeName) {
      event.preventDefault();
      this.form.userType = typeName;
      console.log(this.form.userType);
    },
    close_modal() {
      this.$emit("close");
      this.$store.state.login_modal = false;
    },
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.btnRecend = false;
          this.countdown = 90;
        }
      }, 1000);
    },
    BtnSendCode() {
      if (this.Mobile.length != 11) {
        toast("شماره موبایل وارد شده صحیح نمی باشد", {
          type: "error",
        });
        return;
      }
      console.log("this.form.userType;", this.form.userType);
      let self = this;
      this.loading = true;
      this.btnRecend = true;
      this.inputs = [
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
        { value: "" },
      ];
      this.helperPost("authorization", {
        Mobile: self.Mobile,
        Role: this.form.userType,
      })
        .then((r) => {
          console.log("aaa", r);
          if (r.data.result == "1") {
          this.startTimer();
            self.step = 2;
            this.showerror = false;
            this.$nextTick(() => {
              const input0 = this.inputRefs[0];
              if (input0 && input0.focus) {
                input0.focus();
              }
            });
            toast(r.data.msg, {
              type: "success",
              dangerouslyHTMLString: true,
            });
          } else {
            this.showerror = true;
            this.error_title = r.data.msg;

            toast(r.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    BtnLoginToSite() {
      let self = this;
      self.loading = true;
      if (self.inputs.every((input) => input.value.length != 1)) {
        self.showerror = true;
        self.error_title = "کدی وارد نشده است";
        self.loading = false;
        return false;
      }
      let Code = this.inputs.map((input) => input.value).join("");
      console.log("Code", Code);
      var fire = JSON.parse(localStorage.getItem("fire"));
      this.helperPost("verify", {
        Mobile: this.Mobile,
        Code: Code,
        fire_token: fire,
        Role: this.form.userType,
      })
        .then((r) => {
          // console.log("login", r);
          if (r.data.result == "1") {
            self.$store.commit("setToken", r.data.token);
            self.$store.dispatch("checkToken");
            self.getCustomerinfo();
          } else if (r.data.result == "2") {
            this.step = 3;
          } else {
            toast(r.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },

    getCustomerinfo() {
      let self = this;
      this.helperPost("current-user-info")
        .then((r) => {
          if (r.data.result == "1") {
            self.$store.commit("setAuth", r.data);
            self.$store.dispatch("checkAuth");
            self.close_modal();
            this.$nextTick(() => {
              if (this.$store.state.auth.role != 'customer') {
                this.get_branch_info();
              }
            })
            toast("شما با موفقیت وارد سیستم شده اید", {
              type: "success",
              dangerouslyHTMLString: true,
            });
            setTimeout(function () {
              self.customer_setting();
            }, 1000);
          } else {
            toast(r.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },
    async get_branch_info() {
      await this.helperGet("branch-infos").then((res) => {
        if (res.data.result == "1") {
          localStorage.setItem("branchinof", JSON.stringify(res.data.data));
        }
      });
    },
    customer_setting() {
      this.helperGet("setting")
        .then((res) => {
          this.$store.commit("optionSet", res.data.data);
          this.$store.state.login_modal = false;
          this.$router.push({ path: "/home" });
        })
        .catch((error) => console.log(error));
    },
    BackToSite() {
      this.step = 1;
      clearInterval(this.timer);
      this.countdown = 90;
      this.btnRecend = false;
    },
    handleInput(index) {
      // اگر ورودی پر باشد و مشتری عددی وارد کند
      if (this.inputs[index].value.length === 1) {
        // اگر ورودی بعدی وجود دارد، به آن برو
        if (index < this.inputs.length - 1) {
          const nextInput = this.inputRefs[index + 1];
          if (nextInput && nextInput.focus) {
            nextInput.focus(); // تمرکز بر روی ورودی بعدی
          }
        }
      } else if (this.inputs[index].value.length === 0 && index > 0) {
        // اگر ورودی خالی باشد و مشتری به ورودی قبلی برود
        const prevInput = this.inputRefs[index - 1];
        if (prevInput && prevInput.focus) {
          prevInput.focus(); // تمرکز بر روی ورودی قبلی
        }
      }
    },
    handleKeydown(index, event) {
      if (event.key === "Backspace") {
        // اگر ورودی خالی باشد و مشتری Backspace را فشار دهد
        if (this.inputs[index].value.length === 0 && index > 0) {
          event.preventDefault(); // جلوگیری از رفتار پیش‌فرض
          const prevInput = this.inputRefs[index - 1];
          if (prevInput && prevInput.focus) {
            // پاک کردن مقدار ورودی قبلی
            this.inputs[index - 1].value = ""; // پاک کردن مقدار ورودی قبلی
            prevInput.focus(); // تمرکز بر روی ورودی قبلی
          }
        } else if (this.inputs[index].value.length === 1) {
          // اگر ورودی دارای مقداری باشد
          this.inputs[index].value = ""; // پاک کردن مقدار
          event.preventDefault(); // جلوگیری از رفتار پیش‌فرض
        }
      }
    },

    validation(index, msg) {
      this.errors[index] = msg;
      this.load_page = !this.load_page;
    },
    fnameValidation() {
      if (!this.form.fName.trim()) {
        this.validation(0, "نام را وارد کنید", "fName");
        return;
      } else if (this.form.fName.length < 3) {
        this.validation(0, "نام را صحیح وارد کنید", "fName");
        return;
      } else {
        this.validation(0, "", "fName");
      }
    },
    lnameValidation() {
      if (!this.form.lName.trim()) {
        this.validation(1, "نام خانوادگی را وارد کنید", "lName");
        return;
      } else if (this.form.lName.length < 3) {
        this.validation(1, "نام خانوادگی را صحیح وارد کنید", "lName");
        return;
      } else {
        this.validation(1, "", "lName");
      }
    },
    codeMelliValidation() {
      if (this.form.codeMelli !== "" && this.form.codeMelli.length < 10) {
        this.validation(2, "کدملی باید 10 رقمی باشد", "codeMelli");
        return;
      } else {
        this.validation(2, "", "codeMelli");
      }
    },
    branch_titleMelliValidation() {
      if (!this.form.branch_title.trim()) {
        this.validation(3, "نام املاک را وارد کنید", "branch_title");
        return;
      } else if (this.form.branch_title.length < 3) {
        this.validation(3, "نام املاک را صحیح وارد کنید", "branch_title");
        return;
      } else {
        this.validation(3, "", "branch_title");
      }
    },
    userInfoValidation(event) {
      event.preventDefault();
      this.fnameValidation();
      this.lnameValidation();
      this.codeMelliValidation();
      if (this.form.userType == "branch_admin") {
        this.branch_titleMelliValidation();
      }

      let _error = 0;
      this.errors.forEach((error) => {
        if (error !== "") {
          _error += 1;
        }
      });

      if (_error === 0) {
        return true;
      } else {
        return false;
      }
    },
    verifyRegistration(event) {
      let self = this;
      if (this.userInfoValidation(event)) {
        this.loading = true;
        this.helperPost("signup", {
          Fname: this.form.fName,
          Lname: this.form.lName,
          branch_title: this.form.branch_title,
          Mobile: this.Mobile,
          code_melli: this.form.codeMelli,
          Role: this.form.userType,
        })
          .then((r) => {
            console.log("login", r);
            if (r.data.result == "1") {
              self.$store.commit("setToken", r.data.token);
              self.$store.dispatch("checkToken");
              self.getCustomerinfo();
            } else {
              toast(r.data.msg, {
                type: "error",
                dangerouslyHTMLString: true,
              });
            }
            self.loading = false;
          })
          .catch(function () {
            self.loading = false;
          });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const input0 = this.inputRefs[0];
      if (input0 && input0.focus) {
        input0.focus();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.regFormInput {
  font-size: 0.85rem !important;
}

.auth-layout__button.auth-layout__button--close {
  width: 32px !important;
  height: 32px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #0096c7 !important;
  color: #fff;
  font-size: 16px;
}

.loader {
  width: 30px !important;
  height: 30px !important;
}

@media (max-width: 500px) {
  .authModal {
    backdrop-filter: blur(1px);
    background: rgba(0, 0, 0, 0.2);
  }

  .authLayout {
    border-radius: 0 !important;
  }
}
</style>
